import React from "react";
import List from "../../components/list/List";
import { CCA_DETAILS } from "../../constants/CcaDetails";

export default function CCA() {
    return <List listDetails={CCA_DETAILS} />;
}
